// Mock data for Netflix-like streaming app
// This will be replaced with actual TMDB API data later

export const featuredMovie = {
  id: 1,
  title: "Welcome to TV Home",
  name: "TV Broadcast",
  // add an overview texte of 80 words.
  overview: "Experience the best of television with our curated channels. From thrilling dramas to hilarious comedies, there's something for everyone. Dive into a world of entertainment and discover new favorites. Our TV Broadcast feature brings you the latest shows and timeless classics, all in one place. Don't miss out on the action - tune in now!",
  backdrop_path: "fallback-tv-broadcast.png",
  poster_path: null,
  release_date: null,
  first_air_date: null,
  vote_average: null,
  runtime: null,
  genre_ids: [],
  trailerUrl: "https://www.youtube.com/watch?v=c1J-CSgAKRY",
  vote_count: null
};

export const trendingNow = [
  {
    id: 101,
    title: "The Crown",
    overview: "Follows the political rivalries and romance of Queen Elizabeth II's reign and the events that shaped the second half of the 20th century.",
    backdrop_path: "/wHa6KOJAoNTFLFtp7wguUJKSnju.jpg",
    poster_path: "/1M876KPjulVwppEpldhdc8V4o68.jpg",
    release_date: "2016-11-04",
    vote_average: 8.2,
    genre_ids: [18, 36],
    trailerUrl: "https://www.youtube.com/watch?v=JWtnJjn6ng0",
    vote_count: 8945,
    runtime: 60
  },
  {
    id: 102,
    title: "Money Heist",
    overview: "An unusual group of robbers attempt to carry out the most perfect robbery in Spanish history - stealing 2.4 billion euros from the Royal Mint of Spain.",
    backdrop_path: "/mYM8x2Atv4MaLulaV0KVJWI1Djv.jpg",
    poster_path: "/reEMJA1uzscCbkpeRJeTT2bjqUp.jpg",
    release_date: "2017-05-02",
    vote_average: 8.3,
    genre_ids: [80, 18],
    trailerUrl: "https://www.youtube.com/watch?v=_InqQJRqGW4",
    vote_count: 15672,
    runtime: 70
  },
  {
    id: 103,
    title: "Wednesday",
    overview: "Smart, sarcastic and a little dead inside, Wednesday Addams investigates a murder spree while making new friends — and foes — at Nevermore Academy.",
    backdrop_path: "/iHSwvRVsRyxpX7FE7GbviaDvgGZ.jpg",
    poster_path: "/9PFonBhy4cQy7Jz20NpMygczOkv.jpg",
    release_date: "2022-11-23",
    vote_average: 8.1,
    genre_ids: [35, 80, 14, 9648],
    trailerUrl: "https://www.youtube.com/watch?v=Di310WS8zLk",
    vote_count: 9834,
    runtime: 50
  },
  {
    id: 104,
    title: "The Witcher",
    overview: "Geralt of Rivia, a mutated monster-hunter for hire, journeys toward his destiny in a turbulent world where people often prove more wicked than beasts.",
    backdrop_path: "/7HsHPTi7kSYXrXH4dIVdacewkpP.jpg",
    poster_path: "/cZ0d3rtvXPVvuiX22sP79K3Hmjz.jpg",
    release_date: "2019-12-20",
    vote_average: 8.0,
    genre_ids: [12, 18, 14],
    trailerUrl: "https://www.youtube.com/watch?v=ndl1W4ltcmg",
    vote_count: 11256,
    runtime: 60
  },
  {
    id: 105,
    title: "Bridgerton",
    overview: "Wealth, lust, and betrayal set in the backdrop of Regency era England, seen through the eyes of the powerful Bridgerton family.",
    backdrop_path: "/dWCGNhg4TcK1K2lVcTnRvVK7jR7.jpg",
    poster_path: "/luoKpgVwi1E5nQsi7W0UuKHu2R8.jpg",
    release_date: "2020-12-25",
    vote_average: 7.4,
    genre_ids: [18, 10749],
    trailerUrl: "https://www.youtube.com/watch?v=gpv7ayf_tyE",
    vote_count: 6723,
    runtime: 55
  }
];

export const popularMovies = [
  {
    id: 201,
    title: "Avatar: The Way of Water",
    overview: "Set more than a decade after the events of the first film, learn the story of the Sully family, the trouble that follows them, and the lengths they go to keep each other safe.",
    backdrop_path: "/s16H6tpK2utvwDtzZ8Qy4qm5Emw.jpg",
    poster_path: "/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg",
    release_date: "2022-12-14",
    vote_average: 7.7,
    genre_ids: [878, 12, 28],
    trailerUrl: "https://www.youtube.com/watch?v=d9MyW72ELq0",
    vote_count: 18945,
    runtime: 192
  },
  {
    id: 202,
    title: "Top Gun: Maverick",
    overview: "After thirty years, Maverick is still pushing the envelope as a top naval aviator, but must confront ghosts of his past when he leads TOP GUN's elite graduates on a mission.",
    backdrop_path: "/odJ4hx6g6vBt4lBWKFD1tI8WS4x.jpg",
    poster_path: "/62HCnUTziyWcpDaBO2i1DX17ljH.jpg",
    release_date: "2022-05-24",
    vote_average: 8.3,
    genre_ids: [28, 18],
    trailerUrl: "https://www.youtube.com/watch?v=qSqVVswa420",
    vote_count: 24567,
    runtime: 131
  },
  {
    id: 203,
    title: "Black Panther: Wakanda Forever",
    overview: "Queen Ramonda, Shuri, M'Baku, Okoye and the Dora Milaje fight to protect their nation from intervening world powers in the wake of King T'Challa's death.",
    backdrop_path: "/yYrvN5WFeGYjJnRzhY0QXuo4Isw.jpg",
    poster_path: "/sv1xJUazXeYqALyszSZ8FocY35K.jpg",
    release_date: "2022-11-09",
    vote_average: 7.3,
    genre_ids: [28, 12, 18, 878],
    trailerUrl: "https://www.youtube.com/watch?v=_Z3QKkl1WyM",
    vote_count: 16782,
    runtime: 161
  },
  {
    id: 204,
    title: "The Batman",
    overview: "When the Riddler, a sadistic serial killer, begins murdering key political figures in Gotham, Batman is forced to investigate the city's hidden corruption.",
    backdrop_path: "/b0PlSFdDwbyK0cf5RxwDpaOJQvQ.jpg",
    poster_path: "/74xTEgt0HDSzrCXcW2h27aGPUgL.jpg",
    release_date: "2022-03-01",
    vote_average: 7.8,
    genre_ids: [28, 80, 18],
    trailerUrl: "https://www.youtube.com/watch?v=mqqft2x_Aa4",
    vote_count: 19345,
    runtime: 176
  },
  {
    id: 205,
    title: "Spider-Man: No Way Home",
    overview: "With Spider-Man's identity now revealed, Peter asks Doctor Strange for help. When a spell goes wrong, dangerous foes from other worlds start to appear.",
    backdrop_path: "/14QbnygCuTO0vl7CAFmPf1fgZfV.jpg",
    poster_path: "/1g0dhYtq4irTY1GPXvft6k4YLjm.jpg",
    release_date: "2021-12-15",
    vote_average: 8.4,
    genre_ids: [28, 12, 878],
    trailerUrl: "https://www.youtube.com/watch?v=JfVOs4VSpmA",
    vote_count: 28934,
    runtime: 148
  },
  {
    id: 206,
    title: "Dune",
    overview: "Paul Atreides, a brilliant and gifted young man born into a great destiny beyond his understanding, must travel to the most dangerous planet in the universe to ensure the future of his family and his people.",
    backdrop_path: "/iopYFB1b6Bh7FWZh3onQhph1sih.jpg",
    poster_path: "/d5NXSklXo0qyIYkgV94XAgMIckC.jpg",
    release_date: "2021-09-15",
    vote_average: 8.0,
    genre_ids: [878, 12, 18],
    trailerUrl: "https://www.youtube.com/watch?v=8g18jFHCLXk",
    vote_count: 15678,
    runtime: 155
  },
  {
    id: 207,
    title: "No Time to Die",
    overview: "Bond has left active service and is enjoying a tranquil life in Jamaica. His peace is short-lived when his old friend Felix Leiter from the CIA turns up asking for help.",
    backdrop_path: "/4RLCa9dOJNXdpwJjfUAd6RQzJzC.jpg",
    poster_path: "/iUgygt3fscRoKWCV1d0C7FbM9TP.jpg",
    release_date: "2021-09-30",
    vote_average: 7.4,
    genre_ids: [28, 12, 53],
    trailerUrl: "https://www.youtube.com/watch?v=BIhNsAtPbPI",
    vote_count: 12456,
    runtime: 163
  },
  {
    id: 208,
    title: "The Matrix Resurrections",
    overview: "Plagued by strange memories, Neo's life takes an unexpected turn when he finds himself back inside the Matrix.",
    backdrop_path: "/hNuP6gyYJLDQN6oQcNLhHOPSh9t.jpg",
    poster_path: "/8c4a8kE7PizaGQQnditMmI1xbRp.jpg",
    release_date: "2021-12-16",
    vote_average: 6.7,
    genre_ids: [28, 878, 12],
    trailerUrl: "https://www.youtube.com/watch?v=9ix7TUGVYIo",
    vote_count: 8934,
    runtime: 148
  },
  {
    id: 209,
    title: "Eternals",
    overview: "The Eternals are a team of ancient aliens who have been living on Earth in secret for thousands of years. When an unexpected tragedy forces them out of the shadows, they are forced to reunite against mankind's most ancient enemy, the Deviants.",
    backdrop_path: "/c6H7Z4u73ir3cIoCteuhJh7UCAR.jpg",
    poster_path: "/lFByFSLV5WDJEv3KabbdAF959F2.jpg",
    release_date: "2021-10-18",
    vote_average: 7.1,
    genre_ids: [28, 12, 18, 14],
    trailerUrl: "https://www.youtube.com/watch?v=x_me3xsvDgk",
    vote_count: 11234,
    runtime: 156
  },
  {
    id: 210,
    title: "Fast X",
    overview: "Over many missions and against impossible odds, Dom Toretto and his family have outsmarted, out-nerved and outdriven every foe in their path. Now, they confront the most lethal opponent they've ever faced.",
    backdrop_path: "/4XM8DUTQb3lhLemJC51Jx4a2EuA.jpg",
    poster_path: "/fiVW06jE7z9YnO4trhaMEdclSiC.jpg",
    release_date: "2023-05-17",
    vote_average: 7.2,
    genre_ids: [28, 80, 53],
    trailerUrl: "https://www.youtube.com/watch?v=32RAq6JzY-w",
    vote_count: 14567,
    runtime: 141
  },
  {
    id: 211,
    title: "John Wick: Chapter 4",
    overview: "With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.",
    backdrop_path: "/h4VB6m0RwcicVEZvzftYZyKXs6K.jpg",
    poster_path: "/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg",
    release_date: "2023-03-22",
    vote_average: 7.8,
    genre_ids: [28, 53, 80],
    trailerUrl: "https://www.youtube.com/watch?v=qEVUtrk8_B4",
    vote_count: 18923,
    runtime: 169
  },
  {
    id: 212,
    title: "Guardians of the Galaxy Vol. 3",
    overview: "Peter Quill, still reeling from the loss of Gamora, must rally his team around him to defend the universe along with protecting one of their own.",
    backdrop_path: "/xVMtRAs8PljMCODvZQH6sks4bAD.jpg",
    poster_path: "/r2J02Z2OpNTctfOSN1Ydgii51I3.jpg",
    release_date: "2023-05-03",
    vote_average: 8.0,
    genre_ids: [28, 12, 35, 878],
    trailerUrl: "https://www.youtube.com/watch?v=u3V5KDHRQvk",
    vote_count: 16745,
    runtime: 150
  },
  {
    id: 213,
    title: "Oppenheimer",
    overview: "The story of J. Robert Oppenheimer's role in the development of the atomic bomb during World War II.",
    backdrop_path: "/fm6KqXpk3M2HVveHwCrBSSBaO0V.jpg",
    poster_path: "/8Gxv8gSFCU0XGDykEGv7zR1n2ua.jpg",
    release_date: "2023-07-19",
    vote_average: 8.3,
    genre_ids: [18, 36],
    trailerUrl: "https://www.youtube.com/watch?v=uYPbbksJxIg",
    vote_count: 22876,
    runtime: 180
  },
  {
    id: 214,
    title: "Barbie",
    overview: "Barbie and Ken are having the time of their lives in the colorful and seemingly perfect world of Barbie Land. However, when they get a chance to go to the real world, they soon discover the joys and perils of living among humans.",
    backdrop_path: "/nHf61UzkfFno5X1ofIhugCPus2R.jpg",
    poster_path: "/iuFNMS8U5cb6xfzi51Dbkovj7vM.jpg",
    release_date: "2023-07-19",
    vote_average: 7.2,
    genre_ids: [35, 12, 14],
    trailerUrl: "https://www.youtube.com/watch?v=pBk4NYhWNMM",
    vote_count: 19234,
    runtime: 114
  },
  {
    id: 215,
    title: "Indiana Jones and the Dial of Destiny",
    overview: "Finding himself in a new era, approaching retirement, Indy wrestles with fitting into a world that seems to have outgrown him.",
    backdrop_path: "/5gPQylLilg9VTd1ibNwc9vEbzAF.jpg",
    poster_path: "/Af4bXE63pVsb2FtbW8uYIyPBadD.jpg",
    release_date: "2023-06-28",
    vote_average: 6.9,
    genre_ids: [28, 12],
    trailerUrl: "https://www.youtube.com/watch?v=eQfMbSe7F2g",
    vote_count: 11567,
    runtime: 154
  },
  {
    id: 216,
    title: "Mission: Impossible – Dead Reckoning Part One",
    overview: "Ethan Hunt and his IMF team embark on their most dangerous mission yet, to track down a terrifying new weapon that threatens all of humanity before it falls into the wrong hands.",
    backdrop_path: "/8pjWz2lt29KqVmlIUO31sos4bxj.jpg",
    poster_path: "/NNxYkU70HPurnNCSiCjYAmacwm.jpg",
    release_date: "2023-07-08",
    vote_average: 7.7,
    genre_ids: [28, 53, 12],
    trailerUrl: "https://www.youtube.com/watch?v=avz06PDqDbM",
    vote_count: 15890,
    runtime: 163
  },
  {
    id: 217,
    title: "Ant-Man and the Wasp: Quantumania",
    overview: "Scott Lang and Hope Pym, along with Hope's parents Hank and Janet van Dyne, and Scott's daughter Cassie Lang, find themselves exploring the Quantum Realm, interacting with strange new creatures and embarking on an adventure that will push them beyond the limits of what they thought possible.",
    backdrop_path: "/9Hk9qdCyce04VXNQuDXAK7hBDeS.jpg",
    poster_path: "/qnqGbB22YJ7dSs4o6M7exTpNxPz.jpg",
    release_date: "2023-02-15",
    vote_average: 6.5,
    genre_ids: [28, 12, 35, 878],
    trailerUrl: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
    vote_count: 12456,
    runtime: 124
  },
  {
    id: 218,
    title: "Transformers: Rise of the Beasts",
    overview: "When a new threat capable of destroying the entire planet emerges, Optimus Prime and the Autobots must team up with a powerful faction known as the Maximals. With the fate of humanity hanging in the balance, humans Noah and Elena will do whatever it takes to help the Transformers as they engage in the ultimate battle to save Earth.",
    backdrop_path: "/2vFuG6bWGyQUzYS9d69E5l85nIz.jpg",
    poster_path: "/gPbM0MK8CP8A174rmUwGsADNYKD.jpg",
    release_date: "2023-06-06",
    vote_average: 7.3,
    genre_ids: [28, 12, 878],
    trailerUrl: "https://www.youtube.com/watch?v=itnqEauWQZM",
    vote_count: 13567,
    runtime: 127
  },
  {
    id: 219,
    title: "The Flash",
    overview: "Barry Allen uses his super speed to change the past, but his attempt to save his family creates a world without super heroes, forcing him to race for his life in order to save the future.",
    backdrop_path: "/yF1eOkaYvwiORauRCPWznV9xVvi.jpg",
    poster_path: "/rktDFPbfHfUbArZ6OOOKsXcv0Bm.jpg",
    release_date: "2023-06-14",
    vote_average: 7.0,
    genre_ids: [28, 12, 878],
    trailerUrl: "https://www.youtube.com/watch?v=hebWYacbdvc",
    vote_count: 14789,
    runtime: 144
  },
  {
    id: 220,
    title: "Scream VI",
    overview: "Following the latest Ghostface killings, the four survivors leave Woodsboro behind and start a fresh chapter.",
    backdrop_path: "/44immBwzhDVyjn87b3x3l9mlhAD.jpg",
    poster_path: "/wDWwtvkRRlgTiUr6TyLSMX8FCuZ.jpg",
    release_date: "2023-03-08",
    vote_average: 7.1,
    genre_ids: [27, 9648, 53],
    trailerUrl: "https://www.youtube.com/watch?v=h74AXqw4Opc",
    vote_count: 9876,
    runtime: 122
  },
  {
    id: 221,
    title: "Creed III",
    overview: "Adonis has been thriving in both his career and family life, but when a childhood friend and former boxing prodigy resurfaces, the face-off is more than just a fight.",
    backdrop_path: "/cvsXj3I9Q2iyyIo95AecSd1tad7.jpg",
    poster_path: "/cvsXj3I9Q2iyyIo95AecSd1tad7.jpg",
    release_date: "2023-03-01",
    vote_average: 7.4,
    genre_ids: [18, 28],
    trailerUrl: "https://www.youtube.com/watch?v=AHmCH7iB_IM",
    vote_count: 11234,
    runtime: 116
  },
  {
    id: 222,
    title: "Dungeons & Dragons: Honor Among Thieves",
    overview: "A charming thief and a band of unlikely adventurers undertake an epic heist to retrieve a lost relic, but things go dangerously awry when they run afoul of the wrong people.",
    backdrop_path: "/A7AoNT06aRAc4SV89Dwxj3EYAgC.jpg",
    poster_path: "/A7AoNT06aRAc4SV89Dwxj3EYAgC.jpg",
    release_date: "2023-03-29",
    vote_average: 7.6,
    genre_ids: [12, 35, 14],
    trailerUrl: "https://www.youtube.com/watch?v=IiMinixSXII",
    vote_count: 8765,
    runtime: 134
  },
  {
    id: 223,
    title: "Evil Dead Rise",
    overview: "A twisted tale of two estranged sisters whose reunion is cut short by the rise of flesh-possessing demons, thrusting them into a primal battle for survival.",
    backdrop_path: "/5ik4ATKmNtmJU6AYD0bLm56BCVM.jpg",
    poster_path: "/5ik4ATKmNtmJU6AYD0bLm56BCVM.jpg",
    release_date: "2023-04-12",
    vote_average: 7.0,
    genre_ids: [27, 53],
    trailerUrl: "https://www.youtube.com/watch?v=BIPLNlzIGbA",
    vote_count: 7654,
    runtime: 96
  },
  {
    id: 224,
    title: "Air",
    overview: "The story of Nike's longshot effort to sign rising superstar basketball player Michael Jordan to its shoe company in 1984, an endorsement that seemed impossible at the time but which, thanks to the maverick sneaker salesman, would become the most significant relationship between an athletic brand and an athlete of all time.",
    backdrop_path: "/7RVKvXEtWRJm1FWiJWxOK6bAz9J.jpg",
    poster_path: "/7RVKvXEtWRJm1FWiJWxOK6bAz9J.jpg",
    release_date: "2023-04-05",
    vote_average: 7.4,
    genre_ids: [18, 35],
    trailerUrl: "https://www.youtube.com/watch?v=Euy4Q1TkQMo",
    vote_count: 6543,
    runtime: 111
  },
  {
    id: 225,
    title: "The Super Mario Bros. Movie",
    overview: "While working underground to fix a water main, Brooklyn plumbers—and brothers—Mario and Luigi are transported down a mysterious pipe and wander into a magical new world. But when the brothers are separated, Mario embarks on an epic quest to find Luigi.",
    backdrop_path: "/4fLZUr1e65hKPPVw0R3PmKFKxj1.jpg",
    poster_path: "/qNBAXBIQlnOThrVvA6mA2B5ggV6.jpg",
    release_date: "2023-04-05",
    vote_average: 7.3,
    genre_ids: [16, 12, 10751, 14, 35],
    trailerUrl: "https://www.youtube.com/watch?v=TnGl01FkMMo",
    vote_count: 17890,
    runtime: 92
  }
];

export const newReleases = [
  {
    id: 301,
    title: "Glass Onion: A Knives Out Mystery",
    overview: "World-famous detective Benoit Blanc heads to Greece to peel back the layers of a mystery surrounding a tech billionaire and his eclectic crew of friends.",
    backdrop_path: "/2M2JxEv3HSpjnZWjY9NOdGgfUd.jpg",
    poster_path: "/vDGr1YdrlfbU9wxTOdpf3zChmv9.jpg",
    release_date: "2022-11-23",
    vote_average: 7.1,
    genre_ids: [35, 80, 9648],
    trailerUrl: "https://www.youtube.com/watch?v=qGqiHJTsRkQ",
    vote_count: 8756,
    runtime: 139
  },
  {
    id: 302,
    title: "Enola Holmes 2",
    overview: "Now a detective-for-hire like her infamous brother, Enola Holmes takes on her first official case to find a missing girl.",
    backdrop_path: "/jw3aQ7VCSn5fhqrh7wT0RXeZN6S.jpg",
    poster_path: "/tegBpjM5ODoYoM1NjaiHVLEA0QM.jpg",
    release_date: "2022-11-04",
    vote_average: 6.8,
    genre_ids: [28, 12, 80, 9648],
    trailerUrl: "https://www.youtube.com/watch?v=76qZMHhh9H8",
    vote_count: 6234,
    runtime: 129
  },
  {
    id: 303,
    title: "The Gray Man",
    overview: "When the CIA's most skilled mercenary known as Court Gentry, aka Sierra Six, accidentally uncovers dark agency secrets, he becomes the target.",
    backdrop_path: "/8I37NtDffNV7AhgfcSznxiPC0L1.jpg",
    poster_path: "/5GdOfChyZWnkCUe1ZqHqh5qlC4G.jpg",
    release_date: "2022-07-13",
    vote_average: 6.9,
    genre_ids: [28, 53],
    trailerUrl: "https://www.youtube.com/watch?v=BmllggGO4pM",
    vote_count: 7890,
    runtime: 122
  },
  {
    id: 304,
    title: "Red Notice",
    overview: "An Interpol-issued Red Notice is a global alert to hunt and capture the world's most wanted. But when a daring heist brings together the FBI's top profiler and two rival criminals, there's no telling what will happen.",
    backdrop_path: "/akwg1s7hV5ljeSYFfkw7hTHjVqk.jpg",
    poster_path: "/lAXONuqg41NwUMuzMiFvicDET9Y.jpg",
    release_date: "2021-11-04",
    vote_average: 6.8,
    genre_ids: [28, 35, 80, 53],
    trailerUrl: "https://www.youtube.com/watch?v=Pj0wz7zu3Ms",
    vote_count: 9123,
    runtime: 118
  }
];

export const myList = [
  {
    id: 401,
    title: "The Queen's Gambit",
    overview: "In a Kentucky orphanage in the 1950s, a young girl discovers an astonishing talent for chess while struggling with addiction.",
    backdrop_path: "/34OGjFEbHj0E3lE2w0iTUVq0CBz.jpg",
    poster_path: "/zU0htwkhNvBQdVSIKB9s6hgVeFK.jpg",
    release_date: "2020-10-23",
    vote_average: 8.6,
    genre_ids: [18],
    trailerUrl: "https://www.youtube.com/watch?v=CDrieqwSdgI",
    vote_count: 11567,
    runtime: 60
  },
  {
    id: 402,
    title: "Squid Game",
    overview: "Hundreds of cash-strapped players accept a strange invitation to compete in children's games for a tempting prize, but the stakes are deadly.",
    backdrop_path: "/mYQCdx3Np0DyEYM7nfSKSXmjPKD.jpg",
    poster_path: "/dDlEmu3EZ0Pgg93K2SVNLCjCSvE.jpg",
    release_date: "2021-09-17",
    vote_average: 7.8,
    genre_ids: [18, 9648, 53],
    trailerUrl: "https://www.youtube.com/watch?v=oqxAJKy0ii4",
    vote_count: 16789,
    runtime: 55
  }
];

export const continueWatching = [
  {
    id: 501,
    title: "Ozark",
    overview: "A financial advisor drags his family from Chicago to the Missouri Ozarks, where he must launder $500 million in five years to appease a drug boss.",
    backdrop_path: "/mYM8x2Atv4MaLulaV0KVJWI1Djv.jpg",
    poster_path: "/m73QxqFOVbjaJ7g9BoNGWkp7VzJ.jpg",
    release_date: "2017-07-21",
    vote_average: 8.2,
    genre_ids: [80, 18],
    progress: 65,
    trailerUrl: "https://www.youtube.com/watch?v=5hAXVqrljbs",
    vote_count: 13245,
    runtime: 60
  }
];